/**
 * Consumos diesel y factor CO2.
 * Extraido del PMIS_Tecpetrol.html (lineas ~190-220).
 * Categorias: gal/h vs km/gal segun tipo de equipo.
 */

/** Maquinaria amarilla - consumo en galones por hora */
export const DIESEL_MAQ_AMARILLA: Record<string, number> = {
  "Bulldozer sobre orugas": 7.0,
  "MotoNiveladora - vías/plataformas": 5.8,
  "Retro cargador (Pajarita)": 3.2,
  "Retro Excavadora sobre oruga": 5.0,
  "VibroCompactador": 3.2,
  "Minicargador": 2.5,
};

/** Maquinas herramientas - consumo en galones por hora */
export const DIESEL_MAQ_HERRAMIENTAS: Record<string, number> = {
  "Motosoldadores": 1.0,
  "Compresor aire": 3.7,
  "MIXER - AutoHormigonera": 2.5,
  "Grúa de +80 tons": 6.0,
  "Grúa de hasta 80 tons": 4.5,
  "Manlift": 1.4,
  "Torre de iluminación": 0.5,
  'Dobladora Tubos hasta 6"': 2.0,
  'Dobladora Tubos mayor a 6"': 4.0,
  "Motobomba": 1.3,
  "Carro canasta - Eléctrico": 2.0,
  "Camión Grúa 10 a 15 tons": 3.5,
};

/** Vehiculos de movilizacion - rendimiento en kilometros por galon */
export const DIESEL_VEH_MOVILIZACION: Record<string, number> = {
  "Buseta 20 pasajeros": 20,
  "Buseta 40 pasajeros": 15,
  "Camioneta 4x4": 30,
  "Turbo Camión": 18,
};

/** Vehiculos de carga - rendimiento en kilometros por galon */
export const DIESEL_VEH_CARGA: Record<string, number> = {
  "Cama alta - cabezote 450-560HP": 4,
  "Cama baja - cabezote 450-560HP": 4,
  "CarroTanque sencillo 2200 gal": 10,
  "CarroTanque doble T 4000 gal": 6,
  "CarroTanque mula 10.000 gal": 4,
  "Volqueta": 6,
};

/** Factor de emision de CO2 por galon de diesel (EPA: 0.01016 ton/gal) */
export const CO2_PER_GAL_DIESEL = 0.01016 as const;

export type DieselCategory =
  | "MAQ_AMARILLA"
  | "MAQ_HERRAMIENTAS"
  | "VEH_MOVILIZACION"
  | "VEH_CARGA";

/**
 * Calcula galones consumidos.
 * - Maquinaria (gal/h): cantidad x horas x ratio
 * - Vehiculos (km/gal): cantidad x km / ratio
 */
export function calcularGalones(
  categoria: DieselCategory,
  equipo: string,
  cantidad: number,
  horasOKm: number,
): number {
  const map = {
    MAQ_AMARILLA: DIESEL_MAQ_AMARILLA,
    MAQ_HERRAMIENTAS: DIESEL_MAQ_HERRAMIENTAS,
    VEH_MOVILIZACION: DIESEL_VEH_MOVILIZACION,
    VEH_CARGA: DIESEL_VEH_CARGA,
  }[categoria];

  const ratio = map[equipo];
  if (ratio === undefined) return 0;

  if (categoria === "MAQ_AMARILLA" || categoria === "MAQ_HERRAMIENTAS") {
    // gal/h: galones = cantidad * horas * gal_por_hora
    return cantidad * horasOKm * ratio;
  } else {
    // km/gal: galones = cantidad * km / km_por_gal
    if (ratio === 0) return 0;
    return (cantidad * horasOKm) / ratio;
  }
}

/** Calcula toneladas de CO2 a partir de galones */
export function calcularCO2(galones: number): number {
  return galones * CO2_PER_GAL_DIESEL;
}
